<div class="container p-0">
    <div class="row">
        <div class="col-12 col-sm-6 col-md-4 p-2" *ngFor="let inventoryItem of inventoryItems" style="position: relative">
            <img [src]="inventoryItem.source|resourcePath|async" alt="" style="max-width: 100%" (click)="click(checkbox)">
            <p-checkbox #checkbox name="test" inputId="{{inventoryItem.id}}" value="{{inventoryItem.id}}" [(ngModel)]="selectedItemIds" (click)="click()"></p-checkbox>
        </div>
    </div>
</div>
